(function () {
  var mx = 0, my = 0, tmx = 0, tmy = 0;

  window.addEventListener('pointermove', function (e) {
    tmx = (e.clientX / window.innerWidth - 0.5) * 2;
    tmy = (e.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function frame() {
    requestAnimationFrame(frame);
    if (reduce) return;
    var nodes = document.querySelectorAll('[data-plx]');
    if (!nodes.length) return;
    mx += (tmx - mx) * 0.06;
    my += (tmy - my) * 0.06;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var host = n.parentElement;
      var top = host ? host.getBoundingClientRect().top : 0;
      var scrolled = -top;
      if (scrolled < 0) scrolled = 0;
      var s = parseFloat(n.getAttribute('data-plx')) || 0;
      var m = parseFloat(n.getAttribute('data-plx-mouse')) || 0;
      var rm = parseFloat(n.getAttribute('data-plx-rot-mouse')) || 0;
      var rs = parseFloat(n.getAttribute('data-plx-rot-scroll')) || 0;
      var flip = n.hasAttribute('data-plx-flip') ? -1 : 1;
      var rot = (mx * rm + my * rm * 0.35 + scrolled * rs) * flip;
      n.style.transform =
        'translate3d(' + (mx * m * 26).toFixed(2) + 'px,' + (scrolled * s + my * m * 14).toFixed(2) + 'px,0)' +
        (rot ? ' rotate(' + rot.toFixed(3) + 'deg)' : '');
    }
  }
  requestAnimationFrame(frame);
})();
